import { render, staticRenderFns } from "./TalentMatrices.vue?vue&type=template&id=04ea26a9&scoped=true"
import script from "./TalentMatrices.vue?vue&type=script&lang=js"
export * from "./TalentMatrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea26a9",
  null
  
)

export default component.exports